<template>
  <MenuLayout>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div v-else>
      <!-- Start of Select Filter options -->
      <div class="card bg-light p-3 rounded setting-custom">
        <h4 class="fw-bold text-start">Select Filter Options</h4>
        <hr />
        <div class="row px-4">
          <div class="col-xl-3 col-lg-4 col-md-6" v-for="(column, index) in settingDataList['filters']" :key="index">
            <div class="mb-md-3 mb-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :value="index" :id="'flexCheckDefault' + index"
                  v-model="checkedFilters[index]" :disabled="column === 'Year'" />
                <div class="text-start">
                  <label class="form-check-label" :for="'flexCheckDefault' + index">{{ column }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Select Filter -->
      <!-- Start of Select Columns -->
      <div class="card bg-light p-3 mt-4 rounded">
        <h4 class="fw-bold text-start">Select Columns</h4>
        <hr />
        <div class="row">
          <!-- Select new column list -->
          <div class="col-lg-5 col-md-10 col-sm-12 border bg-white mx-md-5 mb-lg-0 mb-4">
            <div class="bg-white overflow-auto">
              <ul class="list-group scroll-col">
                <li v-for="column in availableColumns" :key="column.id"
                  class="list-group-item list-group-item-action text-start d-flex justify-content-between align-items-center border-0">
                  {{ column }}
                  <i class="bi bi-plus-square fs-5" @click="transferColumn(column)"></i>
                </li>
              </ul>
            </div>
          </div>
          <!-- Selected Columns -->
          <div class="col-lg-5 col-md-10 col-sm-12 border ms-md-5 bg-white">
            <!-- First section with disabled columns -->
            <div class="bg-white overflow-auto">
              <div class="list-group scroll-col">
                <div v-for="(column, index) in defaultSelectedCol" :key="index"
                  class="list-group-item d-flex justify-content-between align-items-center border-0">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-arrows-expand me-3 fs-5 fw-bold disabled-col"></i>
                    <span class="disabled-col">{{ column }}</span>
                  </div>
                  <i class="bi bi-trash3 disabled-button" @click="restoreColumn(column)"></i>
                </div>
                <!-- Second section with draggable columns -->
                <draggable :list="selectedColumns">
                  <div v-for="(column, index) in selectedColumns" :key="index"
                    class="list-group-item list-group-item-action text-s tart d-flex justify-content-between align-items-center border-0">
                    <div>
                      <i class="bi bi-arrows-expand me-3 fs-5 fw-bold" title="Drag"></i>
                      {{ column }}
                    </div>
                    <i class="bi bi-trash3-fill fs-6" @click="restoreColumn(column)"></i>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Select Columns -->
      <div class="d-flex justify-content-center my-3">
        <button class="btn btn-primary" v-on:click.prevent="update_data">Save</button>
        <button class="btn btn-secondary" v-on:click.prevent="reset_data">Cancel</button>
      </div>
    </div>
    <loading-modal :loading="process_loading" :loading_text="loading_text"></loading-modal>
  </MenuLayout>
</template>
<style lang="css" scoped src="@/assets/css/setting.css">
</style>
<script>
import MenuLayout from "@/components/MenuLayout.vue";
import Configuration from "@/Service/configuration.js";
import DataService from "@/Service/data-service.js";
import Swal from "sweetalert2";
import { swal_option } from "@/Util/swal-option.js";
import { VueDraggableNext } from "vue-draggable-next";
import { mapState } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import LoadingModal from '@/components/LoadingModal.vue';
var dataService = new DataService();
var config = new Configuration();
export default {
  components: {
    MenuLayout,
    draggable: VueDraggableNext,
    LoadingSpinner,
    'loading-modal': LoadingModal,
  },
  data() {
    return {
      settingDataList: [], //データベーステーブルの列名
      settingRecordList: [], //フィルターと列レコード
      checkedFilters: [], //値が 1 であるfilter レコード
      saveCheckedFilters: [], // チェックされたフィルター
      defaultSelectedCol: [], // デフォルトで選択された列
      selectedColumns: [], //選択された列
      availableColumns: [], // 左パネルの列
      loading: true,//データの取得
      process_loading: false,
      loading_text: null,
    };
  },
  computed: {
    ...mapState(["userID"]),
  },
  async mounted() {
    var serverResponse = await dataService.retrieveWithGet(
      config.SERVICE_NAME_SETTING
    );
    this.settingDataList = serverResponse.data;
    this.loading = false;
    this.show_data(this.userID);
  },
  watch: {
    checkedFilters: {  //チェックされたフィルター値を更新する
      handler(newVal) {
        this.saveCheckedFilters = this.settingDataList["filters"].filter(
          (filter, index) => newVal[index]
        );
      },
      deep: true,
    },
  },
  methods: {
    async show_data(uid) { //編集時にIDによってデータを表する
      var serverResponse = await dataService.retrieveWithGet(
        config.SERVICE_NAME_SETTING + "/" + uid
      );
      if (serverResponse.success == true) {
        this.settingRecordList = serverResponse.data;
        this.checkedFilters = this.settingRecordList["checkFilterData"]; //デフォルトの無効フィルター
        this.defaultSelectedCol = this.settingRecordList["selectedColumns"].slice(0, 6); //デフォルトで無効になっている列
        this.selectedColumns = this.settingRecordList["selectedColumns"].filter(
          (column) => !this.defaultSelectedCol.includes(column)
        ); //選択された列
        this.availableColumns = this.settingDataList["columns"].filter(
          (column) => !this.defaultSelectedCol.includes(column) && !this.selectedColumns.includes(column)); // 左側のパネルの列を取得する
        this.checkedFilters = this.settingDataList["filters"].map((filter) => this.checkedFilters.includes(filter)); // デフォルトのチェックフィルター
        this.settingDataList["filters"].forEach((filter, index) => {
          if (this.checkedFilters[index]) {
            this.saveCheckedFilters.push(filter);
          }
        }); //チェックしたフィルターを保存する
      }
    },
    async update_data() {
      this.process_loading = true;
      this.loading_text = "Processing";
      var serverResponse;
      const updatedData = [
        this.saveCheckedFilters,
        [...this.defaultSelectedCol, ...this.selectedColumns]
      ];
      // 更新モード
      serverResponse = await dataService.updateWithPut(config.SERVICE_NAME_SETTING + "/" + this.userID,updatedData);
      if (serverResponse.success == true) {
        Swal.fire(swal_option("success", serverResponse.message));
        this.settingRecordList = serverResponse.data; //一覧表にデータを更新する
      }
      this.process_loading = false;
      this.loading_text = null;
    },
    transferColumn(column) {
      this.selectedColumns.push(column);
      const index = this.availableColumns.findIndex((col) => col === column);
      if (index !== -1) {
        this.availableColumns.splice(index, 1);
      }
    },
    restoreColumn(column) {
      const index = this.selectedColumns.findIndex((col) => col === column);
      if (index !== -1) {
        this.selectedColumns.splice(index, 1);
      }
      this.availableColumns.push(column);
      this.availableColumns.sort();
    },
    reset_data() {
      this.show_data(this.userID);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>